module.exports = __webpack_public_path__ + "static/media/Piano_Before.7253f90b.jpg";